.profileHeading {
  margin-bottom: 16px;
}

.profileRow {
  gap: 16px;
  align-items: center;
}

.dropZone {
  min-height: 0;
}

.signOutButton {
  min-width: 120px;
  align-self: flex-end;
}

.sectionHeading {
  margin-top: 8px;
  margin-bottom: 8px;
}
